module.exports = __webpack_public_path__ + "496e3cd1a6cd16b8a39188a825ce188e.pdf";